import { Modal, Button, Container, Row, Col, ProgressBar } from "react-bootstrap";
import React, { useState, useEffect, useContext } from "react";
import { Formik, Form } from 'formik';
import { TASK } from "../../.config/form/network_performance";
import style from "./Modal.module.scss";
import { ReactComponent as Upload } from "../../assets/icons/cloud-upload.svg";
import { ReactComponent as Warning } from "../../assets/icons/exclamation-triangle.svg";
import arrow from "../../assets/icons/arrow-white.svg";
import { ReactComponent as ExcelIcon } from "../../assets/icons/file-earmark-excel-fill.svg";
import { ReactComponent as DeleteIcon } from "../../assets/icons/trash3-fill.svg";
import * as XLSX from 'xlsx';
import ImportFromFileService from "../../HttpService/ImportFromFileService";
import { AuxiliaryService } from '../../HttpService/AuxiliaryService';
import { BsExclamationCircleFill } from "react-icons/bs";
import {TODIS_FORM_FIELD_OPTIONS_GDB} from "../Forms";
import { useNavigate } from "react-router-dom";
import { BsArrowRight } from 'react-icons/bs';
import Swal from 'sweetalert2';
import AuthContext from '../../auth/authContext';
import { RequestService } from "../../HttpService/RequestService";



const TODIS_MODAL_DATACOLLECTION_FILL_IN = (props) => {
    const { task, getllenarform, show, onHide } = props;
    const [upload, setUpload] = useState(false);
    const [NombreArchivo, setNombreArchivo] = useState("");
    const [PesoArchivo, setPesoArchivo] = useState(0);
    const navigate = useNavigate();



    const FileUpload = (e, setFieldValue) => {
        setFieldValue("file", e.currentTarget.files[0]);
        setUpload(true);
        setNombreArchivo(e.currentTarget.files[0].name);
        setPesoArchivo(e.currentTarget.files[0].size);
    };

    const deleteTodo = () => {
        setUpload(false);
    };

    const handleSendFile = async (multipartFile) => {
            const transport = task.requestDetailsDTO.transportType;
            const type = task.requestDetailsDTO.projectType == "TEN-T Network performance monitoring" ? "npm" : "live";
            let formType = transport + '-' + type;
            if (transport == "Freight Terminal") {
                formType = "Freight" + '-' + type;
            } else if (transport == "Inland waterways") {
                formType = "Iww" + '-' + type;
            } else if (transport == "Inland waterway ports") {
                formType = "IwwPorts" + '-' + type;
            }
            const res = await ImportFromFileService.sendFillInFile(multipartFile, task.requestId, formType);
            //console.log("RES: ", res);
        
            handleSendFileCallback(res);
        
    };

    const handleSendFileCallback = (res) => {
        if (res.success == true) {
            Swal.fire(
                'Accepted!',
                `The file has been uploaded properly.`,
                'success'
            );
            /*navigate("/TODIS-APP/WorkFlow");*/
        } else {
            Swal.fire(
                'Denied!',
                `Please fill in all the parameters. There are errors in some fields.`,
                'error'
            );
        }
    };

    useEffect(() => {
    }, []);

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="todis-modal-container"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Importing Data from a file
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Formik
                        initialValues={TASK}
                        onSubmit={async (values, errors) => {
                            setUpload(false);
                            if (values.file.size > 0) {
                                try {
                                    let file = values.file;
                                    let reader = new FileReader();

                                    reader.onload = async function (e) {
                                        let data = new Uint8Array(e.target.result);
                                        let workbook = XLSX.read(data, { type: "array" });
                                        let worksheet = workbook.Sheets[workbook.SheetNames[0]];
                                        let sheet = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                                        //console.log(sheet);
                                        setUpload(false);
                                    }.bind(this);
                                    reader.readAsArrayBuffer(file);
                                } catch (exception) {
                                    console.log(exception);
                                    this.setState({
                                        fileLoaded: false,
                                        fileName: "",
                                        operationInProgress: false
                                    });
                                }
                            } else {
                                alert("No files found", { type: "error" });
                            }
                        }}>
                        {({ values, errors, touched, setFieldValue, handleSubmit, }) => (
                            <Form className="todis-form-content p-0" onSubmit={handleSubmit} method="post">

                                {!upload ?
                                    <div>

                                <Row className={`${"pb-3"}`}>
                                    <div className={`${style.modalbox}`}>
                                    <Col lg={12} >
                                        <div className={style.modalboxtitle}><Upload width="50" height="50"/></div>
                                    </Col>
                                    <Col lg={12}>
                                        <div className={style.modalboxtitle}>  Select the file </div>
                                    </Col>     
                                    <Col lg={12}>
                                        <div className={style.modalboxtitleto}> from your local environment </div>
                                    </Col>    
                                    <Col lg={12}>
                                        <div style={{textAlign:"center"}}>
                                        <input id="file" name="file" type="file" onChange={(event) => {
                                           FileUpload(event,setFieldValue);                                                                                    
                                        }} className={style.fileselect} />
                                        </div>
                                    </Col>
                                    </div>    
                                </Row>                                    
                                    <div className={style.modalboxtitlebutom}>
                                    <Warning width="25" height="25" fill="#FFC61C"/> Maximun File size is 50MB, and supports only xlsx,excel....
                                    </div>
                                </div>
                                :
                               <div>          
                                <Row className={`${"pb-3"}`}>  

                                            <Col lg={1} >
                                                <div>
                                                    <div><ExcelIcon width="50" height="50" fill="#198754" /></div>
                                                </div>
                                            </Col>
                                            <Col lg={11} >
                                                <div>
                                                    <div className={style.modalnamefile}> {`${NombreArchivo}`} <DeleteIcon width="18" height="18" fill="#004494" onClick={() => deleteTodo()} /> </div>
                                                    <div><ProgressBar animated now={100} /></div>
                                                    <div className={style.modalnamefile}><span style={{ opacity: 0.5 }}>{`${PesoArchivo + " of " + PesoArchivo + " bytes"}`}</span> <span style={{ fontWeight: "bold" }}>100%</span> </div>
                                                </div>
                                            </Col>
                                            <div style={{ textAlign: "right", paddingTop: "150px" }}>
                                                <Button variant="outline-primary" onClick={() => deleteTodo()} className="todis-reset-btn" type="reset">DISCARD </Button>
                                                <Button variant="primary" onClick={() => handleSendFile(values.file)} className="todis-submit-btn" type="submit">IMPORT <BsArrowRight size={20}/></Button>
                                            </div>
                                        </Row>
                                    </div>
                                }
                            </Form>
                        )}
                    </Formik>
                </Container>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </Modal>
    )
}

export { TODIS_MODAL_DATACOLLECTION_FILL_IN };